import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock, mergeProps as _mergeProps, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "text-sm"
};
const _hoisted_2 = {
  class: "block"
};
const _hoisted_3 = {
  class: "block text-sm font-medium text-gray-900"
};
import { computed } from 'vue';
export default {
  __name: 'LlRadioGroup',
  props: {
    label: {
      type: String,
      default: ''
    },
    modelValue: {
      type: String,
      default: ''
    },
    /**
     * `{ label, value }`, plus an optional `description` rendered under the label,
     * `descriptionClass` to colour it, and `dataCy`.
     */
    options: {
      type: Array,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    /**
     * Each option as a bordered card, one per line, tinted green when chosen.
     * Defaults to the original inline row.
     */
    cards: {
      type: Boolean,
      default: false
    },
    // false stacks the options vertically. Cards always stack, whatever this says.
    inline: {
      type: Boolean,
      default: true
    }
  },
  emits: ['update:modelValue'],
  setup(__props) {
    const props = __props;
    const isRow = computed(() => props.inline && !props.cards);

    // Inline rather than classes on purpose: Vuetify's `border` and `align-items`
    // rules are !important or share Tailwind's names, so utility classes lose the
    // race for colour. Custom properties and the inline border are not up for it.
    function cardStyle(option) {
      const selected = props.modelValue === option.value;
      return {
        border: '1px solid',
        borderColor: selected ? 'rgb(var(--v-theme-primary))' : '#e0e0e0',
        borderRadius: '4px',
        padding: '12px 14px',
        marginBottom: '10px',
        // The radio sits level with the title, not centred against the whole card.
        alignItems: 'flex-start',
        backgroundColor: selected ? 'rgba(var(--v-theme-primary), 0.08)' : undefined,
        boxShadow: selected ? 'inset 0 0 0 1px rgb(var(--v-theme-primary))' : undefined,
        // Vuetify greys every radio label to 60%; a card's title should read as text.
        '--v-medium-emphasis-opacity': 1
      };
    }
    return (_ctx, _cache) => {
      const _component_v_radio = _resolveComponent("v-radio");
      const _component_v_radio_group = _resolveComponent("v-radio-group");
      return _openBlock(), _createElementBlock("div", null, [__props.label ? (_openBlock(), _createElementBlock("label", _hoisted_1, _toDisplayString(__props.label), 1)) : _createCommentVNode("", true), _createVNode(_component_v_radio_group, _mergeProps({
        modelValue: __props.modelValue,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.$emit('update:modelValue', $event)),
        inline: isRow.value,
        "hide-details": "",
        density: "compact",
        color: "primary",
        disabled: __props.disabled,
        class: {
          '[&_.v-selection-control-group]:items-center': isRow.value
        }
      }, _ctx.$attrs), {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, option => {
          return _openBlock(), _createBlock(_component_v_radio, {
            key: option.value,
            label: option.description ? undefined : option.label,
            value: option.value,
            color: "primary",
            class: _normalizeClass(__props.cards ? 'w-full cursor-pointer hover:bg-[rgba(var(--v-theme-primary),0.04)]' : 'mr-6'),
            style: _normalizeStyle(__props.cards ? cardStyle(option) : undefined),
            "data-cy": option.dataCy
          }, _createSlots({
            _: 2
          }, [option.description ? {
            name: "label",
            fn: _withCtx(() => [_createElementVNode("span", _hoisted_2, [_createElementVNode("span", _hoisted_3, _toDisplayString(option.label), 1), _createElementVNode("span", {
              class: _normalizeClass(["block text-xs mt-1", option.descriptionClass || 'text-gray-600'])
            }, _toDisplayString(option.description), 3)])]),
            key: "0"
          } : undefined]), 1032, ["label", "value", "class", "style", "data-cy"]);
        }), 128))]),
        _: 1
      }, 16, ["modelValue", "inline", "disabled", "class"])]);
    };
  }
};